import axios from "axios";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { errorTypeHandler } from "../utils/ErrorTypes";
import { checkInternetConnection } from "./QueryMethod";
import { useAuth0 } from "@auth0/auth0-react";

const useFetchData = (
    URL,
    method = "GET",
    requestData = null,
    errorHandler
) => {
  const dispatch = useDispatch();
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  const { getAccessTokenSilently } = useAuth0();
  const GetAuthToken = async () => {
    const token = await getAccessTokenSilently();
    return token;
};
  useEffect(async() => {
    setLoading(true);
    const token = await GetAuthToken();
    let response = axios({
      method: "GET",
      url: URL,
      data: requestData && requestData,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        Authorization: `Bearer ${token}`,
      },
      timeout: 30000,
      withCredentials: true
    })
      .then((response) => {
        const { error_code, error_description } = response.data;
        if (parseInt(error_code) === 0) {
          setData(response.data);
        }else if(response.data){
          setData(response.data);

                }

                else {
                    if (errorHandler) {
                        errorHandler({
                            message: error_description,
                            severity: "warning",
                        });
                    }
                }
            })
            .catch((error) => {
                // Checking the internet connection before checking the other error
                checkInternetConnection()
                    .then(() => {
                        // Handling the Timeout Error
                        if (error.message.includes("timeout")) {
                            const { error_description } = errorTypeHandler("timeout");
                            setError(error_description);
                            if (errorHandler) {
                                errorHandler({
                                    message: error_description,
                                    severity: "warning",
                                });
                            }
                            return;
                        }
                        if (error.response) {
                            // error handling related to the client request
                            // The request was made and the server responded with a status code
                            const { error_description } = errorTypeHandler(
                                error.response.status
                            );
                            setError(error_description);
                            if (errorHandler) {
                                errorHandler({
                                    message: error_description,
                                    severity: "warning",
                                });
                            }
                            return;
                        } else if (error.request) {
                            // error handling related to the server response
                            // The request was made but no response was received
                            const { error_description } = errorTypeHandler("NO_RESPONSE");
                            setError(error_description);
                            if (errorHandler) {
                                errorHandler({
                                    message: error_description,
                                    severity: "warning",
                                });
                            }
                            return;
                        } else {
                            // All the Network Error
                            console.log("error.config", error.config);
                        }
                    })
                    .catch((error) => {
                        const { error_description } = errorTypeHandler("NET_DISCONNECTED");
                        setError(error_description);

                        if (errorHandler) {
                            errorHandler({
                                message: error_description,
                                severity: "warning",
                            });
                        }
                    });
            });
    }, []);

    return { loading: loading, data: data, error: error };
};

export default useFetchData;
